import{parsePath,parseQuery}from"./parse/main.js";
import{normalizeQueryArrays}from"./validate/arrays.js";
import{validatePath}from"./validate/path.js";
import{isQueryString}from"./validate/string.js";













































































export const normalizePath=(path)=>{
if(isQueryString(path)){
return parsePath(path)
}

validatePath(path,path);
return path
};


export const normalizeQuery=(query)=>
isQueryString(query)?parseQuery(query):normalizeQueryArrays(query,query);